import {
  Stepper,
} from '@mantine/core';
import {
  useIsFirstRender,
} from '@mantine/hooks';
import {
  notifications,
} from '@mantine/notifications';
import {
  Button,
  CircularProgress,
  createTheme,
  styled,
} from '@mui/material';
import {
  createFileRoute,
  useNavigate,
} from '@tanstack/react-router';
import React, {
  useContext,
  useEffect,
  useState,
} from 'react';
import {
  Form,
} from 'react-bootstrap';
import {
  useAuth,
} from 'react-oidc-context';
import validator from 'validator';

import {
  darkTheme,
} from '#components/themes';
import {
  TextButton,
} from '#components/ui';
import SpeciaLogo2 from '#resources/images/logos/circle-specia-2.png?url';
import SpeciaLogoWithName from '#resources/images/logos/SpeciaLogoWithName.png?url';
import {
  lookupAbn,
  validateAbn,
} from '@specia-accountant/shared';

export const Route = createFileRoute('/_app/_authenticated/setup/owner')({
  component: RouteComponent,
});

function CompanyDetails({
  onNext,
}) {
  const [
    companyName,
    setCompanyName,
  ] = useState('');
  const [
    ABN,
    setABN,
  ] = useState('');
  const auth = useAuth();
  const navigate = useNavigate();
  async function abnChangeHandler(e) {
    console.log(e.target.value);
    setABN(e.target.value);
    if (validateAbn(e.target.value)) {
      let compName: string = await lookupAbn(e.target.value);
      if (compName) {
        setCompanyName(compName);
      }
    }
  }
  async function createCompany() {
    if (!validateAbn(ABN)) {
      notifications.show({
        title: 'Validation Error',
        message: 'The provided ABN is not valid',
        color: 'accent.4',
        autoClose: 10_000,
      });
      return;
    } else {
      const abnStatus = await lookupAbn(ABN);
      if (!abnStatus) {
        notifications.show({
          title: 'Validation Error',
          message: 'The provided ABN is not associated with any organization',
          color: 'accent.4',
          autoClose: 10_000,
        });
        return;
      }
      try {
        const response = await fetch(`${window.origin}/api/company/create`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth.user?.access_token}`,
          },
          body: JSON.stringify({
            compName: companyName,
            abn: ABN,
          }),
        });
        if (response.status === 403) {
          setSessionExpired(true);
          throw new Error('Session expired');
        }
        if (!response.ok) {
          throw new Error('Network response was not ok ' + response.statusText);
        }
        const result = await response.json();
        console.log('Company created successfully', result);
        // Fetch a new token
        auth.signinSilent();
        navigate({
          to: '/mydigitalworkers',
          from: '/setup/owner',
        });
      } catch (error) {
        console.warn(error);
      }
    }
  }
  return (
    <>
      <div
        style={ {
          display: 'flex',
          flexDirection: 'row',
          padding: '5vh 15vw',
        } }
      >
        <div
          style={ {
            flex: 1,
          } }
        >
          <img
            src={ SpeciaLogoWithName }
            width="40%"
            style={ {
              paddingBottom: '12vh',
            } }
            alt="Specia logo"
          />
          <img
            src={ SpeciaLogo2 }
            width="90%"
            style={ {
              paddingBottom: '15vh',
            } }
            alt="Specia logo"
          />
        </div>

        <div
          style={ {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          } }
        >
          <div
            style={ {
              paddingLeft: '10vw',
            } }
          >
            <header>
              <p
                style={ {
                  margin: '0px',
                  color: 'white',
                  fontSize: '1vw',
                  fontWeight: 300,
                } }
              >
                <span
                  style={ {
                    color: 'rgba(255, 255, 255, 0.7)',
                    fontSize: '1vw',
                  } }
                >
                  Welcome to
                </span>
                { ' ' }
                Specia Platform,
              </p>
              <h1
                style={ {
                  fontSize: '1.5vw',
                  marginBottom: '1vw',
                } }
              >
                Tell us about your Organization
              </h1>
              <p
                style={ {
                  color: 'rgba(255, 255, 255, 0.75)',
                  fontSize: '0.85vw',
                  margin: 0,
                } }
              >
                Please fill in the details below to register your organization with us.
              </p>
            </header>

            <Form.Control
              type="text"
              value={ ABN }
              placeholder="Australian Business Number"
              onChange={ abnChangeHandler }
              style={ {
                width: '100%',
                borderRadius: '0.5vw',
                backgroundColor: 'rgb(255, 255, 255, 0.05)',
                fontSize: '0.85vw',
                color: 'white',
                border: 'none',
                padding: '0.25vw 1vw',
                margin: '1vw auto',
                height: '3vw',
              } }
            />
            <Form.Control
              type="text"
              value={ companyName }
              placeholder="Company Name"
              onChange={ e => setCompanyName(e.target.value) }
              style={ {
                width: '100%',
                borderRadius: '0.5vw',
                backgroundColor: 'rgb(255, 255, 255, 0.05)',
                fontSize: '0.85vw',
                color: 'white',
                border: 'none',
                padding: '0.25vw 1vw',
                marginBottom: '1.3vw',
                height: '3vw',
              } }
            />
            <Button
              onClick={ createCompany }
              variant="outlined"
              style={ {
                borderColor: 'rgb(255, 255, 255, 1)',
                color: 'rgb(255, 255, 255, 0.9)',
                padding: '0.7vw',
                marginBottom: '1vw',
                border: 'none',
                backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#f25252, #f25252)',
                borderRadius: '0.5vw',
                textTransform: 'none',
                fontSize: '1vw',
                fontWeight: 500,
                letterSpacing: '0.08vw',
                width: '100%',
                marginTop: '0vw',
              } }
            >
              Continue
            </Button>
            <p
              onClick={ () => navigate({
                to: '/setup',
                from: '/setup/owner',
              }) }
              style={ {
                fontSize: '0.8vw',
                color: 'rgb(255, 255, 255, 0.7)',
                marginTop: '1vw',
                cursor: 'pointer',
              } }
            >
              <span
                dangerouslySetInnerHTML={ {
                  __html: '&larr;',
                } }
                style={ {} }
              />
              { ' ' }
              Previous
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

function Verification({
  onNext, onBack,
}) {
  const auth = useAuth();
  const navigate = useNavigate();
  return (
    <div
      style={ {
        display: 'flex',
        flexDirection: 'row',
        padding: '5vh 15vw',
      } }
    >
      <div
        style={ {
          flex: 1,
        } }
      >
        <img
          src={ SpeciaLogoWithName }
          width="40%"
          style={ {
            paddingBottom: '12vh',
          } }
          alt="Specia logo"
        />
        <img
          src={ SpeciaLogo2 }
          width="90%"
          style={ {
            paddingBottom: '15vh',
          } }
          alt="Specia logo"
        />
      </div>

      <div
        style={ {
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        } }
      >
        <div
          style={ {
            paddingLeft: '10vw',
          } }
        >
          <header>
            <p
              style={ {
                margin: '0px',
                color: 'white',
                fontSize: '1vw',
                fontWeight: 300,
              } }
            >
              <span
                style={ {
                  color: 'rgba(255, 255, 255, 0.7)',
                  fontSize: '1vw',
                } }
              >
                Welcome to
              </span>
              { ' ' }
              Specia Platform,
            </p>
            <h1
              style={ {
                fontSize: '1.5vw',
                marginBottom: '1vw',
              } }
            >
              Organization Verification
            </h1>
            <p
              style={ {
                color: 'rgba(255, 255, 255, 0.75)',
                fontSize: '0.85vw',
                margin: 0,
                marginBottom: '1vw',
              } }
            >
              Please wait while our team is working on verifying your organization details.
            </p>
          </header>

          <Button
            onClick={ onBack }
            variant="outlined"
            style={ {
              borderColor: 'rgb(255, 255, 255, 1)',
              color: 'rgb(255, 255, 255, 0.9)',
              padding: '0.7vw',
              marginBottom: '1vw',
              border: 'none',
              backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#f25252, #f25252)',
              borderRadius: '0.5vw',
              textTransform: 'none',
              fontSize: '1vw',
              fontWeight: 500,
              letterSpacing: '0.08vw',
              width: '100%',
              marginTop: '1vw',
            } }
          >
            Previous
          </Button>
        </div>
      </div>
    </div>
  );
}

export default function RouteComponent() {
  const auth = useAuth();
  const firstRender = useIsFirstRender();
  const stepCount = 2;
  const [
    active,
    setActive,
  ] = useState(0);
  const nextStep = () => setActive(current => (current < stepCount ? current + 1 : current));
  const prevStep = () => setActive(current => (current > 0 ? current - 1 : current));
  useEffect(() => {
    if (firstRender) {
      if (auth.user?.profile.accountant && auth.user?.profile.accountant.ssid) {
        setActive(stepCount - 1);
      }
    }
  }, [
    active,
    firstRender,
  ]);
  return (
    <Stepper
      active={ active }
      onStepClick={ setActive }
      allowNextStepsSelect={ false }
      px="xl"
      pt="md"
      w="100%"
    >
      <Stepper.Step
        label="Company details"
        description="Enter your organization's details"
      >
        <CompanyDetails
          onNext={ nextStep }
          onBack={ prevStep }
        />
      </Stepper.Step>
      <Stepper.Step
        label="Verification"
        description="Complete verification process"
      >
        <Verification
          onNext={ nextStep }
          onBack={ prevStep }
        />
      </Stepper.Step>
      { /* <Stepper.Completed>
        Completed, click back button to get to previous step
      </Stepper.Completed> */ }
    </Stepper>
  );
}
